import { useEffect, useState, useContext } from "react";
import apiClient from "../api/apiClient";
import { useNavigate } from "react-router-dom";

import "../css/mainhome.css";
import Header from "../components/Header";
import GameTabs from "../components/GameTabs";
import ContactBar from "../components/ContactBar";
import GameCard from "../components/GameCard";
import BottomNav from "../components/BottomNav";
import Sidebar from "../components/SideBar";
import ClosedModal from "../components/ClosedModal";
import { AppContext } from "../context/AppContext";
import { toast } from "react-toastify";
import GameTimeModal from "../components/GameTimeModal";

export default function MainHome() {
  const [games, setGames] = useState([]);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [closedGame, setClosedGame] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showGameTime, setShowGameTime] = useState(false);
  const [selectedGame, setSelectedGame] = useState(null);

  const navigate = useNavigate();
  const { user } = useContext(AppContext);

  const [settings, setSettings] = useState({
    bannerText: "Loading...",
    contact1: "",
    contact2: "",
  });

  // ✅ FETCH GAME LIST (Passport standard)
  const fetchGames = async () => {
    try {
      const token = localStorage.getItem("accessToken");

      if (!token) {
        console.warn("Missing token");
        setLoading(false);
        return;
      }

      const response = await apiClient.post("/game-list", {});

      if (response.data.status) {
        setGames(response.data.info || []);
      } else {
        console.warn("Game list fetch failed:", response.data.msg);
        setGames([]);
      }
    } catch (err) {
      console.error("Game list fetch error:", err?.response || err);
      setGames([]);
      toast.error("Failed to load games");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGames();
  }, []);

  // ✅ SETTINGS
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await apiClient.get("/contact-detail");

        if (response.data.status && response.data.info) {
          const { homepageContent, mobileNo, whatsappNo } =
            response.data.info.contactInfo;

          setSettings({
            bannerText: homepageContent,
            contact1: mobileNo,
            contact2: whatsappNo,
          });
        }
      } catch (error) {
        console.error("Failed to fetch app settings:", error);
        setSettings((prev) => ({
          ...prev,
          bannerText: "Failed to load information.",
        }));
      }
    };

    fetchSettings();
  }, []);

  const isAccountActive = user?.accountStatus === true;

  const handleGameClick = (game) => {
    if (!user?.accountStatus) return;

    if (!game.playStatus) {
      setClosedGame(game);
    } else {
      navigate(`/market/${game.gameId}`, {
        state: {
          gameName: game.gameName,
          openBidTime: game.openTime,
        },
      });
    }
  };

  return (
    <div className="mainhome-screen-wrapper" style={{ position: "relative" }}>
      <Header
        walletCount={5}
        onMenuClick={() => setSidebarOpen(true)}
        isAccountActive={isAccountActive}
      />

      {isSidebarOpen && (
        <Sidebar isOpen={isSidebarOpen} onClose={() => setSidebarOpen(false)} />
      )}

      {/* {isAccountActive && <BannerTicker text={settings.bannerText} />} */}
       {isAccountActive && (
        <ContactBar number1={settings.contact1} number2={settings.contact2} />
      )}

      <GameTabs isAccountActive={isAccountActive} whatsappNumber={settings.contact1} />
       {/* <GameTabs isAccountActive={isAccountActive} /> */}

      {/* {isAccountActive && (
        <ContactBar number1={settings.contact1} number2={settings.contact2} />
      )} */}

      <div className="home-market-panel">
        <div className="home-market-heading">
          <span>Markets</span>
          <small>{loading ? "Loading" : `${games.length} available`}</small>
        </div>

        <div className="game-list">
          {!loading &&
            games.map((g) => (
              <div key={g.gameId} onClick={() => handleGameClick(g)}>
                <GameCard
                  title={g.gameName}
                  number={g.result}
                  openTime={g.openTime}
                  closeTime={g.closeTime}
                  closed={!g.playStatus}
                  isAccountActive={user?.accountStatus === true}
                  statusText={g.statusText}
                  onTimeClick={() => {
                    setSelectedGame({
                      gameName: g.gameName,
                      openTime: g.openTime,
                      closeTime: g.closeTime,
                      playStatus: g.playStatus,
                    });
                    setShowGameTime(true);
                  }}
                />
              </div>
            ))}
        </div>
      </div>

      <BottomNav active="Home" whatsappNumber={settings.contact2} />

      {closedGame && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            zIndex: 1000,
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 16px",
          }}
        >
          <ClosedModal game={closedGame} onClose={() => setClosedGame(null)} />
        </div>
      )}

      {showGameTime && (
        <GameTimeModal
          game={selectedGame}
          onClose={() => setShowGameTime(false)}
        />
      )}
    </div>
  );
}
